import React from 'react'

const SvgShoppingCartOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M9.02 20a2 2 0 11-4 0 2 2 0 014 0zM21.025 20a2 2 0 11-4 0 2 2 0 014 0z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.004 2.996a1 1 0 011-1h1.94a1 1 0 01.976.778l.504 2.223h14.58a1 1 0 01.934 1.357l-2.68 7a1 1 0 01-.934.643H7.234a1 1 0 01-.975-.776L4.65 6.218l-.504-2.222H3.004a1 1 0 01-1-1zm4.877 4l1.149 5h9.606l1.914-5H6.881z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.316 12.415l1.633 1.154L8.937 15h10.067a1 1 0 110 2H7.006a1 1 0 01-.817-1.577l2.127-3.008z'
    />
  </svg>
)

export default SvgShoppingCartOutline
